export const detectEmployeeMappingIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * --------e-------------------------- */
    if (cleaned === "delete mapping" || cleaned === "remove mapping") {
        return { intent: "delete_mapping" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) mapping/);
    if (deleteMatch) {
        return { intent: "delete_mapping", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create mapping") || cleaned.includes("add mapping")) {
        return { intent: "create_mapping" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create mapping named (.+)/);
    if (createMatch) {
        return { intent: "create_mapping", name: createMatch[1].trim() };
    }

    return null;
};
